import { Component, Signal } from '@angular/core';
import { OpeningHoursComponent } from '../opening-hours/opening-hours.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ScrollService } from '../../../services/scroll.service';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { BusinessConfiguration } from '../../../state-management/model/interfaces/state.model';
import { ConsentManagementService } from '../../../services/consent-management.service';
import { AnalyticsService } from '../../../services/analytics.service';

/**
 * FooterComponent displays contact information, links, and social media.
 * 
 * Social Media Integration:
 * - Supports major platforms: Facebook, Instagram, WhatsApp, LinkedIn, YouTube, TikTok, Pinterest
 * - Displays platform-specific branded colors and SVG icons
 * - Tracks clicks via analytics service
 * - Responsive design with mobile-optimized layout
 * - Links configured via BusinessConfiguration.socialMediaLinks
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    OpeningHoursComponent,
    RouterModule,
    CommonModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})

export class FooterComponent {

  public configuration: Signal<BusinessConfiguration> = this.websiteState.configuration
  public currentYear: number = new Date().getFullYear();

  constructor(
    private websiteState: WebsiteStateService,
    private consentManagementService: ConsentManagementService,
    private analyticsService: AnalyticsService,
    public scrollService: ScrollService,
  ) {
    // this.contactData = this.websiteState.configuration().contactData;
  }


  sendEmail(): void {
    this.analyticsService.trackContactIntent('email', 'footer');
    if (this.configuration().contactData.email) window.location.href = `mailto:${this.configuration().contactData.email}`;
    else window.location.href = `mailto:${'du@dein-unternehmen.de'}`;
  }

  openCookieConsent(): void {
    this.consentManagementService.showPreferencesModal();
  }

  getSocialMediaIconClass(platform: string): string {
    const platformLower = platform.toLowerCase();
    return `social-icon-${platformLower}`;
  }

  trackSocialMediaClick(platform: string): void {
    this.analyticsService.trackClick(`footer-social-media-${platform.toLowerCase()}`);
  }
}